import "vuetify/styles";
import { createVuetify, type ThemeDefinition } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import { en, fr } from "vuetify/locale";

import { appConfig } from "@/types/appConfig.type";
import { phosphorVueIconSet } from "@/plugins/phosphor";

const industrialLight: ThemeDefinition = {
  dark: false,
  colors: {
    background: "#F7FBF9",
    surface: "#FFFFFF",

    primary: "#559A1B",
    secondary: "#E0B23A",

    error: "#C24141",
    info: "#2563EB",
    success: "#4FAE8A",
    warning: "#E0B23A",

    onBackground: "#1F2D27",
    onSurface: "#1F2D27",
  },
};

export default createVuetify({
  locale: {
    locale: appConfig.VITE_DEFAULT_LOCALE,
    fallback: appConfig.VITE_FALLBACK_LOCALE,
    messages: { fr, en },
  },

  icons: {
    defaultSet: "phosphorVue",
    sets: { phosphorVue: phosphorVueIconSet },
    aliases: {
      prev: "PhCaretLeft",
      next: "PhCaretRight",
      close: "PhX",
      clear: "PhX",
      calendar: "PhCalendar",
    },
  },

  theme: {
    defaultTheme: "industrialLight",
    themes: {
      industrialLight
    },
  },

  defaults: {
    VApp: {
      style: "font-family: 'Inter', system-ui, sans-serif;",
    },
    VAppBar: {
      elevation: 0,
      color: "surface",
    },
    VCard: {
      rounded: "lg",
      elevation: 0,
    },
    VBtn: {
      class: "text-none",
      variant: "elevated",
      height: 48,
      rounded: "lg",
    },
    VTextField: {
      rounded: true,
      color: "primary",
      density: "compact",
      variant: "outlined",
    },
  },

  components,
  directives,
});
